import { apiClient, createIdempotencyKey } from "../../shared/api/httpClient";

export async function getLatestIdentityVerification() {
  try {
    const response = await apiClient.get("/identity/real-name-verifications/latest/");
    return response.data;
  } catch (error) {
    if (error.response?.status === 404) return null;
    throw error;
  }
}

export async function startIdentityVerification({ channel = "PROVIDER" } = {}) {
  const response = await apiClient.post("/identity/real-name-verifications/", {
    client_request_id: createIdempotencyKey("identity-verification"),
    channel,
  });
  return response.data;
}

export async function simulateIdentityVerificationSuccess() {
  const response = await apiClient.post(
    "/identity/real-name-verifications/simulate-success/",
  );
  return response.data;
}
